import { Plugin } from '../../types'
import NielsenEventHandler, {
  StreamingAnalyticsPlayerEvent,
} from './NielsenEventHandler'

const JW_PLAYER_STATE_PLAYING = 'playing'

export interface MmsNielsenTrackingData {
  duration: number
  format: string
  id: number
  seriesTitle?: string | null
  title: string
}

const mmsNielsen = (trackingData: MmsNielsenTrackingData): Plugin => {
  return async (jwPlayer: jwplayer.JWPlayer & JWPlayerStatic) => {
    const eventHandler = new NielsenEventHandler(jwPlayer, trackingData)

    window.addEventListener('beforeunload', eventHandler.onUnload)

    jwPlayer.on('remove', () => {
      window.removeEventListener('beforeunload', eventHandler.onUnload)
      eventHandler.onUnload()
    })

    jwPlayer.on('pause', () => {
      eventHandler.sendEvent(StreamingAnalyticsPlayerEvent.STOP)
    })

    jwPlayer.on('buffer', event => {
      if (event.oldstate === JW_PLAYER_STATE_PLAYING) {
        eventHandler.sendEvent(StreamingAnalyticsPlayerEvent.STOP)
      }
    })

    jwPlayer.on('complete', eventHandler.onComplete)

    jwPlayer.on('time', eventHandler.onTime)

    jwPlayer.on('firstFrame', eventHandler.onFirstFrame)
  }
}

export default mmsNielsen
